import { useTopPlaylists } from "@/lib/api";
import { Skeleton } from "@mui/material";
import PlaylistSwiper from "./PlaylistSwiper";

const TopOfRegion = ({ active, onPlay }) => {
  const { playlists, isLoading } = useTopPlaylists("regional");

  const handlePlayed = (playlist) => {
    if (onPlay && typeof onPlay === "function") {
      onPlay(playlist);
    }
  };

  if (isLoading) {
    return (
      <Skeleton variant="rectangular" sx={{ width: "100%", height: "24rem" }} />
    );
  }

  return (
    <PlaylistSwiper
      playlists={playlists}
      prefix="Sound of"
      onPlay={handlePlayed}
      active={active}
    />
  );
};

export default TopOfRegion;
